import FaqForm from './FaqForm';

export default FaqForm;
